<template>
  <div>
    <div class="product-content" v-if="!loading">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <!--基础设置-->
        <Basic :form="form"></Basic>
        <!--其它-->
        <Other :form="form"></Other>
      </el-form>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import projectApi from '@/api/project.js';
import Basic from './part/Basic.vue';
import Other from './part/Other.vue';
export default {
  components: {
    /*基础设置*/
    Basic,
    /*其它*/
    Other
  },
  data() {
    return {
      form: {
        /* 活动id */
        porject_id:'',
        /*活动名称*/
        title: '',
        
        introduce:'',
        
        status: 1,
        /*默认排序*/
        sort: 100,
        /*预算*/
        budget:0,
        longitude:'',
        latitude:'',
        address:'',
        user_id:'',
        view:''

      },
      /*判断是否正在加载*/
      loading: false,
    };
  },
  created() {
    this.form.project_id = this.$route.query.project_id;
    this.getData();
  },
  methods: {

    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      projectApi.getProject(
        {
          project_id: self.form.project_id
        },
        true
      )
        .then(res => {

          let tempForm=res.data.detail;
          tempForm.project_id = self.form.project_id;
          tempForm.coordinate = tempForm.latitude+','+tempForm.longitude;
          self.form = tempForm;

          self.loading = false;
  
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
        
          let params = self.form;
          self.loading = true;
          projectApi.editProject(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              //self.$router.push('/plus/project/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/project/project/edit.vue